import * as style from '../utils/general_style';

const forms = {
    aboutField: 'apropos',
    contactDetails: 'coordonnees',
    contact: 'contact',
    espacePro: 'espacepro'
};
const { aboutField, contactDetails, contact, espacePro } = forms;

export const allInputs = [
    {
        label: 'Nom',
        name: 'name',
        type: 'text',
        required: true,
        forms: [contactDetails, contact, espacePro]
    }, {
        label: 'Prénom',
        name: 'firstName',
        type: 'text',
        required: true,
        forms: [contactDetails, contact, espacePro]
    }, {
        label: 'Téléphone',
        name: 'telephone',
        type: 'number',
        required: false,
        forms: [contactDetails, contact, espacePro]
    }, {
        label: 'Email',
        name: 'email',
        type: 'email',
        required: true,
        forms: [contactDetails, contact, espacePro]
    },{
        label: 'Rue',
        name: 'rue',
        type: 'text',
        required: true,
        forms: [contactDetails]
    }, {
        type: 'devided',
        name: 'contact',
        devidedInputs: [
            {
                label: 'Code Postal',
                name: 'codePostal',
                type: 'number',
                required: true,
                size: '26%'
            }, {
                label: 'Ville',
                name: 'ville',
                type: 'text',
                required: true,
                size: '70%'
            }
        ],
        forms: [contactDetails, espacePro],
    }, {
        label: 'Adresse du Terrain',
        name: 'rueTerrain',
        type: 'text',
        required: true,
        forms: [aboutField]
    }, {
        type: 'devided',
        name: 'terrain',
        devidedInputs: [
            {
                label: 'Code Postal',
                name: 'codePostalTerrain',
                type: 'number',
                required: true,
                size: '26%'
            }, {
                label: 'Ville',
                name: 'villeTerrain',
                type: 'text',
                required: true,
                size: '70%'
            }
        ],
        forms: [aboutField],
    }, {
        label: 'Vous êtes ?',
        name: 'vousEtes',
        type: 'select',
        options: [
            {
                value: '',
                label: 'Choisir...',
                forms: [contact, espacePro]
            }, {
                value: 'client',
                label: 'Client',
                forms: [contact]
            }, {
                value: 'expert',
                label: 'Expert',
                forms: [contact]
            },{
                value: 'geotechnicien',
                label: 'Géotechnicien',
                forms: [contact, espacePro]
            }, {
                value: 'sondeur',
                label: 'Sondeur',
                forms: [contact, espacePro]
            }, {
                value: 'autre',
                label: 'Autre',
                forms: [contact, espacePro]
            }
        ],
        required: true,
        forms: [contact, espacePro]
    }, {
        label: 'Société',
        name: 'company',
        type: 'text',
        required: false,
        forms: [espacePro]
    }, {
        label: 'Sujet',
        name: 'subject',
        type: 'text',
        required: true,
        forms: [contact, espacePro]
    }, {
        label: 'Délai souhaité',
        name: 'deadline',
        type: 'select',
        options: [
            {
                value: '',
                label: 'Choisir...',
                forms: [aboutField]
            }, {
                value: 'urgent',
                label: 'Urgent',
                forms: [aboutField]
            }, {
                value: '2to3',
                label: '2 à 3 semaines',
                forms: [aboutField]
            },{
                value: '4to5',
                label: '4 à 5 semaines',
                forms: [aboutField]
            }, {
                value: '6to7',
                label: '6 à 7 semaines',
                forms: [aboutField]
            }, {
                value: '10orMore',
                label: 'Au delà de 10 semaines',
                forms: [aboutField]
            }
        ],
        required: true,
        forms: [aboutField]
    }, {
        type: 'radio',
        title: 'Caractéristique du terrain',
        answers: [
            {
                label: 'moins de 1000m²',
                value: 'moinsDeMille'
            }, {
                label: 'plus de 1000m²',
                value: 'plusDeMille'
            }
        ],
        forms: [aboutField]
    }, {
        type: 'radio',
        title: 'Portail: 1m de large min sans obstacle à moins de 2m',
        answers: [
            {
                label: 'Oui',
                value: 'portalYes'
            }, {
                label: 'Non',
                value: 'portalNo'
            }
        ],
        forms: [aboutField]
    }, {
        type: 'radio',
        title: 'Présence de réseau',
        answers: [
            {
                label: 'Oui',
                value: 'networkYes'
            }, {
                label: 'Non',
                value: 'networkNo'
            }, {
                label: 'Ne sais pas',
                value: 'networkIndifference'
            }
        ],
        forms: [aboutField]
    }
];

export const typeDevis = [
    {
        label: 'G1: Je vends mon terrain', 
        value: 'G1'
    }, {
        label: 'G2: Je construis une maison',
        value: 'G2'
    }
];

export const docsToSend = [
    {
        label: 'Section cadastrale',
        name: 'sectionCadastrale',
        legend: <p style={{fontStyle: 'italic', fontSize: '12px', color: style.COLORS.darkGrey}}>Si vous ne connaissez pas votre numéro de section, vous pouvez le trouver sur <a style={{...style.INLINE_LINK}} href="www.cadastre.gouv.fr">www.cadastre.gouv.fr</a></p>
    },{
        label: 'Numéro de parcelles',
        name: 'numeroParcelles'
    },{
        label: 'Extrait cadastral',
        name: 'extraitCadastral'
    },{
        label: 'Plan de situation',
        name: 'planSituation'
    },{
        label: `Autorisation d'accès sur site et contraintes de circulation`,
        name: 'autorisationAcces'
    },{
        label: 'Photos des accès',
        name: 'photosAcces'
    },{
        label: 'Plan topographique au droit du projet',
        name: 'planTopographique'
    }    
];